module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst headline = config.headline || {}\nheadline.contentKey = headline.contentKey || config.headlineKey\nconst pricesSetByJobIDs = model.pricesSetByJobIDs || {}\nconst markers = model.jobPriceMarkers = {}\n%><div><%\nif(headline.contentKey){\n%><%- include('../../../../base/form/elements/static_headline', { formMapping: headline, }) %><%\n}\n%><div class=\"list\"><%\nif(utils.collectionSize(model.entities) < 1){\n%><p class=\"empty\"><%= storage.__('form.fields.selectEmployeeJobs.emptyJobList') %></p><%\n} else {\nlet toggle, entity, entityKey, jobID, attributes;\nlet buttonsClasses\nfor(entityKey in model.entities){\nentity = model.entities[entityKey] || {}\nattributes = entity.attributes || {}\njobID = attributes.jobID\ntoggle = entity.toggle || {}\nbuttonsClasses = ['buttons'].concat(markers[jobID] || [])\n%><div class=\"entry\" data-job-id=\"<%= jobID %>\"><%\n%><%- include('../../../../base/form/fields/toggle', { model: { dataINT: toggle.value, fieldCode: toggle.fieldCode, 'boolean-data': toggle.options, atom: { dataType: 'boolean' }, config: { strict: true, singleButtonSwitch: true } }}) %><%\n%><%- include('../../../../base/form/elements/label', { model: { label: entity.title }}) %><%\nif(config.showJobDescriptions && attributes.description){\n%><%- include('../../../../base/tooltip/tooltip', { model: { title: attributes.title, message: attributes.description }, config: { orientation: 'SE-NE', autoCorrectScrollOffset: true } }) %><%\n}\nif(config.showOnRegistrationMarkers && attributes.showOnRegistration){\n%><%- include('../../tooltip/showOnRegistrationMarkers/tooltip', { config: { orientation: 'SE-NE', autoCorrectScrollOffset: true } }) %><%\n}\nif(model.showSetEmployeeJobPriceButton){\n%><div class=\"<%= buttonsClasses.join(' ')%>\"><%\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'setEmployeeJobPrice', context: 'employee', symbolOnly: true, fieldConfig: { disabled: false } } }); %><%\n%></div><%\n}\n%></div><%\n}\n}\n%></div><%\n%></div>"
  , __filename = "components/templates/core/form/fields/selectEmployeeJobs.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const headline = config.headline || {}
headline.contentKey = headline.contentKey || config.headlineKey
const pricesSetByJobIDs = model.pricesSetByJobIDs || {}
const markers = model.jobPriceMarkers = {}

    ; __line = 6
    ; __append("<div>")
    ; 
if(headline.contentKey){

    ; __line = 8
    ; __append( include('../../../../base/form/elements/static_headline', { formMapping: headline, }) )
    ; 
}

    ; __line = 10
    ; __append("<div class=\"list\">")
    ; 
if(utils.collectionSize(model.entities) < 1){

    ; __line = 12
    ; __append("<p class=\"empty\">")
    ; __append(escapeFn( storage.__('form.fields.selectEmployeeJobs.emptyJobList') ))
    ; __append("</p>")
    ; 
} else {
let toggle, entity, entityKey, jobID, attributes;
let buttonsClasses
for(entityKey in model.entities){
entity = model.entities[entityKey] || {}
attributes = entity.attributes || {}
jobID = attributes.jobID
toggle = entity.toggle || {}
buttonsClasses = ['buttons'].concat(markers[jobID] || [])

    ; __line = 22
    ; __append("<div class=\"entry\" data-job-id=\"")
    ; __append(escapeFn( jobID ))
    ; __append("\">")
    ; 

    ; __line = 23
    ; __append( include('../../../../base/form/fields/toggle', { model: { dataINT: toggle.value, fieldCode: toggle.fieldCode, 'boolean-data': toggle.options, atom: { dataType: 'boolean' }, config: { strict: true, singleButtonSwitch: true } }}) )
    ; 

    ; __line = 24
    ; __append( include('../../../../base/form/elements/label', { model: { label: entity.title }}) )
    ; 
if(config.showJobDescriptions && attributes.description){

    ; __line = 26
    ; __append( include('../../../../base/tooltip/tooltip', { model: { title: attributes.title, message: attributes.description }, config: { orientation: 'SE-NE', autoCorrectScrollOffset: true } }) )
    ; 
}
if(config.showOnRegistrationMarkers && attributes.showOnRegistration){

    ; __line = 29
    ; __append( include('../../tooltip/showOnRegistrationMarkers/tooltip', { config: { orientation: 'SE-NE', autoCorrectScrollOffset: true } }) )
    ; 
}
if(model.showSetEmployeeJobPriceButton){

    ; __line = 32
    ; __append("<div class=\"")
    ; __append(escapeFn( buttonsClasses.join(' ')))
    ; __append("\">")
    ; 

    ; __line = 33
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'setEmployeeJobPrice', context: 'employee', symbolOnly: true, fieldConfig: { disabled: false } } }) )
    ; 

    ; __line = 34
    ; __append("</div>")
    ; 
}

    ; __line = 36
    ; __append("</div>")
    ; 
}
}

    ; __line = 39
    ; __append("</div>")
    ; 

    ; __line = 40
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/fields/selectEmployeeJobs.ejs

}